import { render, staticRenderFns } from "./dragFormCollapse.vue?vue&type=template&id=60a2503b&"
import script from "./dragFormCollapse.vue?vue&type=script&lang=js&"
export * from "./dragFormCollapse.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports